import { EmployeeTrackLogStore } from './employee-track-log-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new EmployeeTrackLogStore());
}
